import styled from 'styled-components';
import { colors, paddingV, paddingW } from '../constants';
import { AiTwotoneSetting } from 'react-icons/ai';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setColor } from '../store/color';


const Settings = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const color = useSelector(state => state.colorSlice.value);
  const cogFn = () => {
    setIsOpen(!isOpen);
  }
  const setColorFn = (e) => {
    if(e.target.localName === "button") {
      dispatch(setColor(e.target.dataset.color));
    }
  }
  return (
    <Setting>
      {isOpen && (
      <Colors onClick={setColorFn}>
        {colors.map((color, idx) => (
          <button key={idx} style={{backgroundColor: color}} data-color={color}></button>
        ))}
      </Colors>)}
      <SettingIcon color={color} onClick={cogFn} />
    </Setting>
  )
}

export default Settings;

const Setting = styled.div`
  position: fixed;
  bottom: ${paddingV};
  right: ${paddingW};
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  z-index: 1;
`;
const SettingIcon = styled(AiTwotoneSetting)`
  font-size: 2rem;
  @media screen and (max-width: 500px) {font-size: 1.5rem;}
  cursor: pointer;
  transition: fill 0.1s ease-in-out;
  &:hover {
    fill: ${props => props.color};
  }
`;
const Colors = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  row-gap: 1rem;
  padding: 1rem 0;
  background-color: #fff;
  border-radius: 1rem;
  button {
    border: none;
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    cursor: pointer;
    opacity: 0.5;
    &.active {
      opacity: 1;
    }
  }
`;